import { Flex } from "@mantine/core";
import { FEATURE_SHIPMENTS_DESKTOP_LAYOUT } from "common/constants";
import { ChatModal, ChatPanel } from "components/Chat";
import DesktopHeader from "components/DesktopHeader";
import SideMenuBar from "components/Layout/SideMenuBar";
import { useFeatureSupport } from "hooks/useFeatureSupport";
import { useIsDesktop } from "hooks/useMediaQueries";
import { useScrollVisibility } from "hooks/useScrollVisibility";
import { Outlet } from "react-router";
import HeaderResponsive from "../HeaderResponsive";
import OfflineBar from "./OfflineBar";
import TemporaryLayout from "./TemporaryLayout";

const Layout: React.FC = () => {
  const visible = useScrollVisibility();
  const isDesktop = useIsDesktop();
  const isFirstRender = isDesktop === undefined;
  const { isFeatureEnabled } = useFeatureSupport();
  const isSupportedDesktopLayout = isFeatureEnabled(
    FEATURE_SHIPMENTS_DESKTOP_LAYOUT
  );

  if (!isSupportedDesktopLayout) {
    return <TemporaryLayout />;
  }

  if (isFirstRender) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col font-work-sans">
      {isDesktop && <DesktopHeader />}
      {!isDesktop && <HeaderResponsive visible={visible} />}

      <SideMenuBar />

      <Flex
        ff={"Work Sans"}
        fz={"sm"}
        lh={"sm"}
        bg={"gray.1"}
        pl={{ lg: 56 }}
        w={"100%"}
        h={"100%"}
        flex={1}
        direction={"column"}
        justify={"flex-end"}
      >
        <div className="flex flex-col flex-1 relative">
          <Outlet />

          {isDesktop && <ChatPanel />}
          {!isDesktop && <ChatModal />}
        </div>
      </Flex>
      {!isDesktop && <OfflineBar />}
    </div>
  );
};

export default Layout;
